import React from 'react';
import { VideoPlayer } from '~/components/VideoPlayer';
import { PageTitle } from '~/components/PageTitle';
import GetDemoButton from '~/components/Buttons/GetDemoButton';
import { Container, CategoryProductsMenu } from './styles';

const CategoryHeader = ({ activeTab }) => {
  return (
    <Container>
      <CategoryProductsMenu>
        <PageTitle>Cardápio</PageTitle>
      </CategoryProductsMenu>
    </Container>
  );
};

export default CategoryHeader;
